import { CommonModule, DOCUMENT } from '@angular/common';
import { Inject, NgModule, Optional, SkipSelf } from '@angular/core';
import { NzIconModule, NzIconService } from 'ng-zorro-antd/icon';
import { InlineSVGModule } from '@nano/common/image';
import { icons } from './icon';

@NgModule({
  imports: [CommonModule, InlineSVGModule, NzIconModule.forRoot(icons)],
  exports: [NzIconModule, InlineSVGModule]
})
export class IconModule {
  constructor(@Optional() @SkipSelf() parentModule: IconModule, iconService: NzIconService, @Inject(DOCUMENT) document: Document) {
    if (parentModule) {
      throw new Error('IconModule is already loaded, iport it only once.');
    }

    iconService.changeAssetsSource(new URL('.', document.baseURI).toString());
  }
}
